import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { formatAddress } from '../../../../Dispatch/utils/utils';
const styles = (theme) => ({
  detailsContainer: {
    marginTop: 14,
    marginBottom: 14
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  name: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  address: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400
  }
});

const HoldCustomerDetails = ({ classes, proData }) => {
  const { name, code, address, address2, city, state, zip } = proData || {};
  return (
    <div className={classes.detailsContainer}>
      <div className={classes.headerContainer}>
        <span className={classes.name}>{name}</span>
        <span className={classes.name}>#{code}</span>
      </div>
      <div>
        <span className={classes.address}>
          {formatAddress({ address, address2, city, state, zip })}
        </span>
      </div>
    </div>
  );
};

export default withStyles(styles)(HoldCustomerDetails);
